module.exports = __webpack_public_path__ + "img/accueil-photo-chambre.ca3764e9.jpg";